import { Button } from "@/components/ui/button";
import whatsappIcon from "@/assets/whatsapp-icon.png";

const WhatsAppButton = () => {
  const whatsappNumber = "919910961228";
  const defaultMessage = "Hi! I'd like to know more about your wellness programs.";

  const handleWhatsAppClick = () => {
    const url = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(defaultMessage)}`;
    window.open(url, "_blank", "noopener,noreferrer");
  };

  return (
    <>
      {/* Desktop Version */}
      <div className="hidden md:block fixed bottom-6 right-6 z-50 animate-in fade-in slide-in-from-bottom-4 duration-500">
        <div className="relative">
          {/* Glow effect */}
          <div className="absolute inset-0 rounded-full bg-[#25D366]/20 blur-xl animate-pulse" />

          <Button
            onClick={handleWhatsAppClick}
            size="default"
            aria-label="Chat on WhatsApp"
            className="relative rounded-full h-14 px-6 shadow-2xl hover:shadow-[0_8px_30px_rgb(37,211,102,0.4)] 
                       transition-all duration-300 bg-[#25D366] hover:bg-[#20BD5A] 
                       text-white border-0 group hover:scale-105 active:scale-95"
          >
            <img 
              src={whatsappIcon} 
              alt="WhatsApp" 
              className="w-6 h-6 mr-2 group-hover:scale-110 transition-all duration-300"
            />
            <span className="font-semibold">Chat</span>
          </Button>
        </div>
      </div>

      {/* Mobile Version */}
      <div className="md:hidden fixed bottom-6 right-6 z-50 animate-in fade-in slide-in-from-bottom-4 duration-500">
        <div className="relative">
          {/* Glow effect */}
          <div className="absolute inset-0 rounded-full bg-[#25D366]/20 blur-lg animate-pulse" />

          <Button
            onClick={handleWhatsAppClick}
            size="icon"
            aria-label="Chat on WhatsApp"
            className="relative rounded-full h-14 w-14 shadow-2xl hover:shadow-[0_8px_30px_rgb(37,211,102,0.4)] 
                       transition-all duration-300 bg-[#25D366] hover:bg-[#20BD5A] 
                       text-white border-0 hover:scale-110 active:scale-95"
          >
            <img 
              src={whatsappIcon} 
              alt="WhatsApp" 
              className="w-7 h-7"
            />
          </Button>
        </div>
      </div>
    </>
  );
};

export default WhatsAppButton;
